/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Schema for a GeoJSON Point geometry.
 * @export
 * @interface ActivationPositionSchema
 */
export interface ActivationPositionSchema {
    /**
     * GeoJSON geometry type
     * @type {string}
     * @memberof ActivationPositionSchema
     */
    type?: string;
    /**
     * Coordinates [longitude, latitude]
     * @type {Array<number>}
     * @memberof ActivationPositionSchema
     */
    coordinates: Array<number>;
}

/**
 * Check if a given object implements the ActivationPositionSchema interface.
 */
export function instanceOfActivationPositionSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "coordinates" in value;

    return isInstance;
}

export function ActivationPositionSchemaFromJSON(json: any): ActivationPositionSchema {
    return ActivationPositionSchemaFromJSONTyped(json, false);
}

export function ActivationPositionSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivationPositionSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'coordinates': json['coordinates'],
    };
}

export function ActivationPositionSchemaToJSON(value?: ActivationPositionSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
    };
}

